
/**
 * Created by ttsounis on 01/02/18.
 */
(function() {
    'use strict';
    angular
        .module('soopkitchenApp')
        .factory('SoopkitchenUtils', SoopkitchenUtils);

    SoopkitchenUtils.$inject = ['$rootScope', 'Planning'];

    function SoopkitchenUtils($rootScope, Planning) {

        var defaultSwalParams = {
            customClass: 'swal-custom'
        };

        return {
            invokeSweetAlert : invokeSweetAlert,
            invokeSweetAlertWithParams : invokeSweetAlertWithParams,
            prettyError : prettyError,
            processResponse : processResponse,
            prettyConfirm : prettyConfirm,
            panicConfirm : panicConfirm,
            unlockPrompt : unlockPrompt,
            bookmarkPrompt : bookmarkPrompt,
            saveBaselinePrompt : saveBaselinePrompt,
            sanityChecksResult : sanityChecksResult,
            showPlanChanges : showPlanChanges,
            unlockPlan : unlockPlan,
            lockPlan : lockPlan,
            dateToSeconds: dateToSeconds,
            timeToSeconds : timeToSeconds,
            secondsToTime : secondsToTime,
            secondsElapsedFrom : secondsElapsedFrom,
            timeStringElapsed : timeStringElapsed,
            addTimeStringToDate : addTimeStringToDate,
            roundDecimals : roundDecimals,
            formattedDate : formattedDate,
            formatIsoZuluDateString : formatIsoZuluDateString,
            isValidDate : isValidDate,
            sort : sort,
            removeIndexFromArray : removeIndexFromArray,
            padNumber : padNumber,
            getDayOfYear : getDayOfYear,
            extractArrayFromMap: extractArrayFromMap,
            styleForInstantEvent: styleForInstantEvent,
            updatePlanFromDialog : updatePlanFromDialog,
            prettyConfirmHtml: prettyConfirmHtml,
            prettyHtml: prettyHtml,
            resultEMCMandQuiet: resultEMCMandQuiet
        };

        function padNumber(num, size) {
            var s = num + "";
            while (s.length < size) s = "0" + s;
            return s;
        }

        function getDayOfYear(date) {
            return padNumber(moment.utc(date).format('DDD'), 3);
        }

        function invokeSweetAlert(title, text, type, callback) {
            invokeSweetAlertWithParams({title: title, text: text, type: type}, callback);
        }

        function invokeSweetAlertWithParams(params, callback) {
            var fullParams = Object.assign({}, defaultSwalParams, params);
            swal(fullParams, callback);
        }

        function prettyError(response, callback) {
            prettyAlert(response, '', '', callback);
        }

        function processResponse(response, title, message, callback) {
             prettyAlert(response, title, message, callback);
        }

        function prettyAlert(response, title, message, callback) {
            if (response.status === 0) {
                invokeSweetAlert('Server not reachable', 'Server not reachable', 'error', callback);
            } else {
                var errorHeaders = Object.keys(response.headers()).filter(function (header) {
                    return header.indexOf('app-detailserror-') >= 0;
                });
                if (errorHeaders.length > 0) {
                    processErrorHeaders(response, title, message, errorHeaders, callback);
                }
                else if (response.status >= 200 && response.status < 299) {
                    invokeSweetAlert(title, message, 'success', callback);
                } else {
                    processRestOfTheErrors(response, callback);
                }
            }
        }

        function processErrorHeaders(response, title, message, errorHeaders, callback) {
            var type = 'error';
            if (response.status >= 200 && response.status < 299) {
                type = 'warning';
            }
            var newTitle = response.headers("X-soopkitchenApp-titleError");
            if (title) {
                newTitle = title + ', ' + newTitle;
            }
            var details = '';
            if (message) {
                details = '<h4>' + prepareStringForHtml(message) + '</h4><hr/>'
            }
            details += '<div class="table-wrapper-scroll-x table-wrapper-scroll-y">';
            for (var i = 0; i < errorHeaders.length; i++) {
                var error = prepareStringForHtml(response.headers(errorHeaders[i]));
                details += '<div class="div-in-error">' + error + '</div>';
            }
            details += '</div>';
            invokeSweetAlertWithParams({
                title: newTitle,
                text: details,
                html: true,
                type: type,
                customClass: 'swal-wide',
                showCancelButton: callback != null,
                confirmButtonColor: "#DD6B55"
            }, callback);
        }

        function processRestOfTheErrors(response, callback) {
            var headers = Object.keys(response.headers()).filter(function (header) {
                return header.indexOf('app-error', header.length - 'app-error'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
            }).sort();
            var errorHeader = response.headers(headers[0]);
            if (errorHeader) {
                invokeSweetAlert('Error', errorHeader, 'error', callback);
            }
        }

        function prettyConfirm(title, text, callback) {
            invokeSweetAlertWithParams({
                title: title,
                text: text,
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: "#DD6B55"
            }, callback);
        }

        function prettyConfirmHtml(title, text, callback) {
            invokeSweetAlertWithParams({
                title: title,
                text: text,
                html: true,
                customClass: 'swal-wide',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: "#DD6B55"
            }, callback);
        }

        function prettyHtml(title, text, type, callback) {
            invokeSweetAlertWithParams({
                title: title,
                text: text,
                html: true,
                customClass: 'swal-wide',
                type: type,
                showCancelButton: true,
                confirmButtonColor: "#DD6B55"
            }, callback);
        }

        function panicConfirm(title, text, callback) {
            invokeSweetAlertWithParams({
                title: "<h1>Panic Button</h1>",
                text: "<img  height='183' width='245' src='content/images/panic.jpg'/> <br>" + text,
                showCancelButton: true,
                html: true,
                confirmButtonColor: "#DD6B55"
            }, callback);
        }

        function unlockPrompt(title, text, callback) {
            invokeSweetAlertWithParams({
                title: title,
                text: text,
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                html: true
            }, callback);
        }

        function bookmarkPrompt(callback) {
            invokeSweetAlertWithParams({
                title: "Bookmark",
                text: "Your about to bookmark the status of the plan. Please add a comment",
                type: "input",
                showCancelButton: true,
                closeOnConfirm: false,
                animation: "slide-from-top",
                inputPlaceholder: "Comment"
            }, callback);
        }

        function saveBaselinePrompt(callback) {
            invokeSweetAlertWithParams({
                title: "Saving Baseline",
                text: "Your about to save the baseline for the plan. Please add a comment",
                type: "input",
                showCancelButton: true,
                closeOnConfirm: false,
                animation: "slide-from-top",
                inputPlaceholder: "Comment"
            }, callback);
        }

        function resultEMCMandQuiet(response, callback, confirmationMessage) {
            var type = 'success';
            var happenings = response.eventsTimeline.happenings;

            var text = '<div class="table-wrapper-scroll-x table-wrapper-scroll-y">'
            text += '<table class="jh-table table table-striped"><tbody>';
            text += '<thead><tr>';
            text += '<th>Dates</th>';
            text += '</tr></thead>';
            // for (var i = 0; i < happenings.length; i++) { text+=happenings[i].startDate + "-" + happenings[i].endDate+ "\n"; }
            var fullMsg = "";
            for (var i = 0; i < happenings.length; i++) {
                var cssClass = 'class="label label-info"';
                text += '<tr>';
                var check = '<span ' + cssClass + '>' + happenings[i].startDate + "-" + happenings[i].endDate + '<br>' + '</span> ';
                text += '<td nowrap style="text-align:left;vertical-align:top">' + check + '</td>';
                text += '</tr>';
            }
            text += '</tbody></table></div>';
            if (confirmationMessage != null) {
                text+="<div>"+confirmationMessage+"</div>";
            }
            invokeSweetAlertWithParams({
                title: "EMC",
                showCancelButton: callback != null,
                text: text,
                html: true,
                type: type,
                customClass: 'swal-wide',
                animation: "slide-from-top",
            }, callback);
        }
        function sanityChecksResult(response, callback, confirmationMessage) {
            var type = 'success';
            var data = angular.fromJson(response.data);

            var text = '<div class="table-wrapper-scroll-x table-wrapper-scroll-y">'
            text += '<table class="jh-table table table-striped"><tbody>';
            text += '<thead><tr>';
            text += '<th>Check</th>';
            text += '<th>Messages</th>';
            text += '</tr></thead>';
            for (var i = 0; i < data.length; i++) {

                var cssClass = 'class="label label-info"';
                if (data[i].status === 'FAILED') {
                    type = 'error';
                    cssClass = 'class="label label-danger"';
                }

                var fullMsg = '';
                for (var j = 0; j < data[i].msg.length; j++) {
                    fullMsg += prepareStringForHtml(data[i].msg[j]) + '<br>';
                }

                text += '<tr>';
                var check = '<span ' + cssClass + '>' + prepareStringForHtml(data[i].status) + '</span> ' + prepareStringForHtml(data[i].name);
                text += '<td nowrap style="text-align:left;vertical-align:top">' + check + '</td>';
                text += '<td nowrap style="text-align:left;vertical-align:top">' + fullMsg + '</td>';
                text += '</tr>';
            }
            text += '</tbody></table></div>';
            if (confirmationMessage != null) {
                text+="<div>"+confirmationMessage+"</div>";
            }
            invokeSweetAlertWithParams({
                title: "Sanity Checks",
                showCancelButton: callback != null,
                text: text,
                html: true,
                type: type,
                customClass: 'swal-wide',
                animation: "slide-from-top",
            }, callback);
        }

        function showPlanChanges(response, callback) {
            var messages = response.messages || []; // Extract messages list

            var text = '<div class="table-wrapper-scroll-y">';
            text += '<table class="jh-table table table-striped"><tbody>';

            for (var i = 0; i < messages.length; i++) {
                text += '<tr>';
                text += '<td style="text-align:left;vertical-align:top">';
                text += prepareStringForHtmlChanges(messages[i]); // Ensure proper formatting
                text += '</td>';
                text += '</tr>';
            }

            text += '</tbody></table></div>';

            invokeSweetAlertWithParams({
                title: "Plan Changes",
                showCancelButton: false,
                text: text,
                html: true,
                type: 'info',
                customClass: 'swal-wide',
                animation: "slide-from-top",
            }, callback);
        }




        function unlockPlan(label, planType, successCallback) {
            Planning.unlock(
                {
                    planType: planType,
                    planLabel: label,
                },
                function () {
                    successCallback();
                },
                function () {
                }
            );
        }

        function lockPlan(label, planType, successCallback) {
            Planning.lock(
                {
                    planType: planType,
                    planLabel: label,
                },
                function () {
                    invokeSweetAlert('Nice', 'You locked plan ' + label, 'success');
                    successCallback();
                },
                function () {
                    invokeSweetAlert('Ooops', 'There was a problem locking the plan', 'error');
                }
            );
        }

        function dateToSeconds(inputDate) {
          var dateObject;
          if (inputDate == null) {
            return 0;
          } else if (inputDate instanceof Date) {
            dateObject = inputDate;
          } else {
            dateObject = new Date(inputDate);
          }
          return dateObject.getTime() / 1000;
        }

        function timeToSeconds (timeString) {
            var totalSeconds = 0;
            var numberString = "";
            if (isNaN(timeString[timeString.length-1]) === false) return 0;
            for (var i = 0; i < timeString.length; i++) {
                if (isNaN(timeString[i])) {
                    switch(timeString[i]) {
                        case "d":
                            totalSeconds += (3600*24) * parseInt(numberString) ;
                            break;
                        case "h":
                            totalSeconds += (3600) * parseInt(numberString) ;
                            break;
                        case "m":
                            totalSeconds +=  60 * parseInt(numberString) ;
                            break;
                        case "s":
                            totalSeconds += parseInt(numberString) ;
                            break;
                        default:
                            return 0;
                            break;
                    }
                    numberString = "";
                } else {
                    numberString =  numberString + timeString[i];
                }
            }
            return totalSeconds;
        }

        function secondsElapsedFrom(anchorDate, currentDate) {
            var anchorDateSeconds = Date.parse(anchorDate).valueOf() / 1000;
            var currentDateSeconds = Date.parse(currentDate).valueOf() / 1000;
            return currentDateSeconds - anchorDateSeconds;
        }

        function timeStringElapsed(anchorDate, currentDate) {
            return secondsToTime (secondsElapsedFrom(anchorDate, currentDate));
        }

        function addTimeStringToDate(anchorDate, timeString) {
            var seconds = timeToSeconds(timeString);
            return new Date(Date.parse(anchorDate).valueOf() + seconds * 1000);
        }

        function secondsToTime (secs) {
            secs = Math.round(secs);
            var days =  Math.floor( secs / (24*60*60));

            var divisor_for_hours = secs % (60 * 60 *24);
            var hours = Math.floor( divisor_for_hours / (60*60));

            var divisor_for_minutes = secs % (60 * 60);
            var minutes = Math.floor(divisor_for_minutes / 60);

            var divisor_for_seconds = divisor_for_minutes % 60;
            var seconds = Math.ceil(divisor_for_seconds);

            var obj = {
                "d": days,
                "h": hours,
                "m": minutes,
                "s": seconds
            };

            var time = "";
            if (obj.d > 0) {
                time += obj.d + 'd';
            }
            if (obj.h > 0) {
                time += obj.h + 'h';
            }
            if (obj.m > 0) {
                time += obj.m + 'm';
            }
            if (obj.s > 0) {
                time += obj.s + 's';
            }
            return time;
        }

        function roundDecimals (number, n) {
            if (number == null) return "";
            return Number(number.toFixed(n)).toString();
        }

        function formattedDate(date) {
            if (date == null) return "";
            return  date.toISOString().split('.')[0]+"Z";
        }

        function formatIsoZuluDateString(dateStr) {
            if (!dateStr) return "";
            return  dateStr.substring(0, 10) + " " + dateStr.substring(11, 16);
        }

        function isValidDate(date) {
            return (Date.parse(date) >0 && false === isNaN(Date.parse(date)));
        }

        function sort(listOccurrences, predicate, reverse) {
            listOccurrences.sort(function(a, b) {
                var condition;
                if (isNaN(a[predicate])) {
                    if (!a[predicate] && !b[predicate]) {
                        return 0;
                    }
                    if (!a[predicate] && b[predicate]) {
                        condition = 1;
                    }
                    else if (a[predicate] && !b[predicate]) {
                        condition = -1;
                    }
                    else if (String(a[predicate]).toUpperCase() === String(b[predicate].toUpperCase())) {
                        return 0;
                    } else {
                        condition = String(a[predicate]).toUpperCase() > String(b[predicate].toUpperCase());
                    }
                } else {
                    if (a[predicate] === b[predicate]) {
                        return 0;
                    }
                    condition = a[predicate] > b[predicate];
                }
                if (reverse) {
                    condition = !condition;
                }
                if (condition) {
                    return 1;
                } else if (false === condition) {
                    return -1;
                }
                return 0;
            });
            return listOccurrences;
        }

        function prepareStringForHtml(str) {
            return str.replace('&', '&amp;').replace('<', '&lt;').replace('>', '&gt;');
        }

        function prepareStringForHtmlChanges(str) {
            if (typeof str !== 'string') {
                str = String(str);  // Convert to string if needed
            }
            return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        }

        function removeIndexFromArray(array, index) {
            if (index !== -1) {
                array.splice(index, 1);
            }
        }
        function extractArrayFromMap(map, id) {
            var array = [];
            for (var key in map) {
                // check if the property/key is defined in the object itself, not in parent
                if (map.hasOwnProperty(key)) {
                    var obj = map[key];
                    obj[id] = key;
                    array.push(obj);
                }
            }
            return array;
        }
        function styleForInstantEvent(style) {
            style += "width:10px; ";
            style += "height: 10px; ";
            style += "height: 10px; ";
            style += "border: 2px solid ";
            style += "-webkit-transform: rotate(45deg) skew(15deg, 15deg); ";
            style += "-moz-transform: rotate(45deg) skew(15deg, 15deg); ";
            style += "-ms-transform: rotate(45deg) skew(15deg, 15deg); ";
            style += "-o-transform: rotate(45deg) skew(15deg, 15deg); ";
            style += "transform: rotate(45deg) skew(15deg, 15deg);";
            return style;
        }

        function updatePlanFromDialog(data) {
            $rootScope.$broadcast('updateList', {
                data: data
            });
        }
    }
})();
